import React from 'react';
import PropTypes from 'prop-types';

import { EDIT_STATUS } from 'constants/index';
import { useUser } from 'store/user';
import {
  Tab as MatTab,
} from '@material-ui/core';
import {
  UiContentTabs,
  UiMatTabs,
} from './ContentTabs.style';

export const ContentTabs = ({ editStatus, hostId, tabIndex, onChange, }) => {
  const [{ profile }] = useUser();

  /* change tab */
  const changeHandler = (e, newTabIndex) => {
    onChange(newTabIndex);
  };

  return (
    <UiContentTabs>
      <UiMatTabs value={tabIndex} onChange={changeHandler}>
        <MatTab label='機構資源'/>
        <MatTab label='公開資源'/>
        <MatTab label='我的資源' disabled={hostId !== profile.id || editStatus !== EDIT_STATUS.COPY} /> 
      </UiMatTabs>
    </UiContentTabs>
  );
};

ContentTabs.propTypes = {
  hostId: PropTypes.string,
  editStatus: PropTypes.string,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
};